export default "__VITE_ASSET__D0XqMYuO__"